<template>
  <sweet-modal hide-close-button :title="$t('modal_title_setNameAndEmail')" blocking ref="signInPublicUserToMeetingModal" class="modal" v-on:close="close">
    <el-form :model="form" ref="form" status-icon :rules="rules">
      <el-form-item :label="$t('clients_name')" prop="name" size="mini">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item prop="email" :label="$t('clients_email')" size="mini" style="margin-top: 15px;">
        <el-input v-model="form.email" size="mini"></el-input>
      </el-form-item>
      <p><span style="color: #F56C6C;">*</span> {{$t('meetings_yourDataIsNotSaved')}}</p>
      <el-form-item class="modal__btn" style="float:right;">
        <el-button @click="save('form')" type="primary">{{$t('general_enter')}}</el-button>
      </el-form-item>
    </el-form>
  </sweet-modal>
</template>

<script>
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
export default {
  name: "signInPublickUserToMeetingModal",
  components: {
    SweetModal
  },
  data(){
    return {
      form: {
        name: null,
        email: null
      },
      rules: {
          name: [{
            required: true,
            message: this.$t('modal_settings_fieldIsRequired'),
            trigger: 'blur'
          }],
          email: [
            { required: true, message: this.$t('modal_settings_fieldIsRequired'), trigger: 'blur' },
            { type: 'email', message: this.$t('modal_settings_pleaseInputCorrectEmailAddress'), trigger: 'blur' }
          ],
      }
    }
  },
  methods: {
    openModal() {
      this.$refs.signInPublicUserToMeetingModal.open()
    },
    save(form){
      this.$refs[form].validate((valid) => {
        if (valid) {
          const copy = Object.assign({}, this.form)
          this.$emit('connectPublic', copy)
          this.$refs.signInPublicUserToMeetingModal.close()
        }
      })
    },
    close(){
      this.form.name = null
      this.form.email = null
      this.$refs['form'].resetFields();
    }
  }
}
</script>

<style scoped>

</style>
